import { Component, ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LatLon } from '../model/latlon';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';
import { debounceTime } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { HighlightPipe } from 'src/app/pipe/highlight.pipe';
import { SkeletonLoaderComponent } from 'src/app/common/skeleton-loader/skeleton-loader.component';
import { AlertService } from 'src/app/services/alert.service';
import { MaterialModule } from "src/app/material.module";

declare const google: any;

@Component({
  selector: 'app-map-dailog',
  standalone: true,
  imports: [CommonModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatIcon, HighlightPipe, SkeletonLoaderComponent, MaterialModule],
  templateUrl: './map-dailog.component.html'
})
export class MapDailogComponent {
  latlon: LatLon;

  map!: any;
  marker!: any;
  infoWindow!: any;
  getCityList: any;
  selected_place: any;
  location: any;
  searchText: string='';
  searchingLoader: boolean;
  searchedData: any;

  public searchReport: FormControl;
  show_search_result = false;

  @HostListener('document:click', ['$event'])
  onOutside(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    // Check if the click is outside the active div
    const clickedInside = this.eRef.nativeElement.querySelector(`.property-search`)?.contains(clickedElement);
    if (!clickedInside) {
      this.show_search_result = false;
    }
  }
  place_holder = 'Enter Name, Coordinates, Parcel #, UID or Project Name';

  constructor(private eRef: ElementRef,
    private dialogRef: MatDialogRef<MapDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public Data: any,
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: any,
    private userService: UserService,
    private alertService: AlertService) {

    this.location = window.location;
    this.searchReport = new FormControl();

  }

  ngOnInit(): void {
    this.getCitis();
    this.searchReport.valueChanges.pipe(debounceTime(500)).subscribe((term: any) => {
      term = term.toLowerCase();
      this.show_search_result = true
      if (term && term.length > 0) {
        this.searchProp(term);
      } else {
        this.searchedData = [];
        this.searchText = '';
      }
    })
  }

  clearSearch() {
    this.searchReport.patchValue('');
    this.searchText = '';
    this.searchedData = [];
    this.show_search_result = false;
    this.searchingLoader = false;
  }

  showSearch() {
    this.show_search_result = true;
  }
  searchProp(searchedText: string = '') {
    if (!this.selected_place?.place_id) {
      this.alertService.warning("Please select a city to search.");
      return;
    }
    this.searchText = searchedText.trim();

    this.searchingLoader = true;
    this.userService.getMapSearchedDetail(searchedText, this.selected_place.place_id).subscribe({
      next: (res: any) => {
        this.searchingLoader = false;
        if (res?.status == 200) {
          this.searchedData = res.data;
          // Handle case where userInfo is null or undefined
        } else {
          this.searchedData = [];
        }
      },
      error: (err: any) => {
        this.searchingLoader = false;
        this.searchedData = [];
      },
    });
  }


  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.Data.latlng?.lat && this.Data.latlng?.lng) {
        this.latlon = this.Data.latlng;
        this.intiMap();
      } else {
        try {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                // ✅ Success case
                this.latlon = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                };
                this.intiMap();
              },
              (error) => {
                switch (error.code) {
                  case error.PERMISSION_DENIED:
                    alert("User denied location request");
                    break;
                  case error.POSITION_UNAVAILABLE:
                    alert("Location information unavailable");
                    break;
                  case error.TIMEOUT:
                    alert("Location request timed out");
                    break;
                  default:
                    alert("Unknown error occurred");
                    break;
                }
                this.latlon = { lat: 24.713679050668613, lng: 46.67510821294586 };
                this.intiMap();
              }
            );
          } else {
            console.warn('Geolocation not supported by this browser.');
            this.latlon = { lat: 24.713679050668613, lng: 46.67510821294586 };
            this.intiMap();
          }
        } catch (error) {
          console.error('Error initializing geolocation:', error);
          this.latlon = { lat: 24.713679050668613, lng: 46.67510821294586 };
          this.intiMap();
        }
      }

    }

  }

  selectionOnChange() {
    this.clearSearch();
    if (this.selected_place.place_code.toLowerCase() == 'kwt') {
      this.place_holder = "Enter Name, Coordinates, Parcel #, PACI, Survey Block #, UID or Project Name";
    } else if (this.selected_place.place_code.toLowerCase() == 'ryd') {
      this.place_holder = "Enter Name, Coordinates, Parcel #, Survey Block #, UID, Plan no or Project Name";
    } else {
      this.place_holder = 'Enter Name, Coordinates, Parcel #, UID or Project Name';
    }
    this.SetMaplatlon(this.selected_place.latitude, this.selected_place.longitude,8)
  }

  SetMaplatlon(lat: any, lon: any, zoom:number=8) {
    const latLng = new google.maps.LatLng(lat, lon);
    if (this.marker) this.marker.setMap(null);
    if (this.map) this.map.panTo(latLng);
    // zoom 
    if (this.map && this.map.getZoom() != zoom) this.map.setZoom(zoom);

    this.marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      draggable: true,
    });
    this.showPopup(lat, lon);
    this.marker.addListener('dragend', (event: any) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.showPopup(lat, lng);
    });

  }

  getCitis() {
    this.apiService.get(`${environment.umsUrl}${apiEndPoints.place}?status=1`, true).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          let client_host = this.location.hostname;
          let mainCityList: any = [];
          let citis: any[] = res.data;
          citis.sort((a, b) => a.place_name.localeCompare(b.place_name));
          citis.map((city: any) => {
            var temp = new Array();
            var str = city.domain ? city.domain : '';
            temp = str ? str.split(',') : [];
            if (city?.child_data && city?.child_data?.length > 0) {
              city.child_data.map((e: any) => {
                str = e.domain ? e.domain : '';
                temp = str ? str.split(',') : [];
                if ((e.status == 1 || e.status == 2) && temp.indexOf(client_host) > -1) {
                  e['parent_name'] = city?.place_label;
                  e['search_param'] = city.place_name + ', ' + e.place_name + ' ' + city?.place_label?.['2'] + ', ' + e?.place_label?.['2'];
                  mainCityList.push(e);
                }
              })
            } else {
              if ((city.status == 1 || city.status == 2) && temp.indexOf(client_host) > -1) {
                city['search_param'] = city.place_name + ' ' + city?.place_label?.['2'];
                mainCityList.push(city);
              }
            }
          });
          this.getCityList = mainCityList;
        } else {
          this.getCityList = []
        }
      },
      error: (err) => {
        this.getCityList = []
      }
    })
  }

  intiMap() {
    const mapDiv = document.getElementById('map');
    if (!mapDiv || !(window as any).google) return;

    const initialPos = this.latlon;

    this.map = new google.maps.Map(mapDiv, {
      center: initialPos,
      zoom: 6,
      minZoom: 5,
      maxZoom: 23,
      zoomControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      rotateControl: false,
      scaleControl: false,
    });

    this.marker = new google.maps.Marker({
      position: initialPos,
      map: this.map,
      draggable: true,
    });

    this.infoWindow = new google.maps.InfoWindow();

    // Marker drag event
    this.marker.addListener('dragend', (event: any) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.showPopup(lat, lng);
    });

    // Map click event
    this.map.addListener('click', (event: any) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.marker.setPosition(event.latLng);
      this.showPopup(lat, lng);
    });

  }

  showPopup(lat: number, lng: number): void {
    this.latlon = {
      lat: lat,
      lng: lng
    }
    const content = `
      <div style="color: #333; padding: 0px 6px;">
        <p style="margin: 4px 0;">Latitude : <b>${lat.toFixed(9)}</b></p>
        <p style="margin: 4px 0;">Longitude : <b>${lng.toFixed(9)}</b></p>
      </div>
    `;
    this.infoWindow.setContent(content);
    this.infoWindow.open(this.map, this.marker);
  }

  locateSearchedParcelOnMap(data: any) {
    this.SetMaplatlon(data.lat, data.lon, 17);
    this.show_search_result = false;
  }

  next() {
    this.dialogRef.close(this.latlon)
  }

  close() {
    this.dialogRef.close()
  }
}
